import { useEffect, useState } from 'react'
import { getClient } from '../client'
import { detectLang } from '../types'
import type { LocaleString } from '../types'
import type { SanityImageSource } from '@sanity/image-url'

const HOME_QUERY = `{
  "page": *[_type == "homePage" && _id == "singleton-homePage"][0] {
    newsHeading, headerImage
  },
  "featuredArticle": *[_type == "newsArticle" && isFeatured == true && language == $lang] | order(publishedAt desc)[0] {
    _id, title, slug, image
  },
  "articles": *[_type == "newsArticle" && language == $lang] | order(publishedAt desc)[0...3] {
    _id, title, slug, image
  },
  "infoCards": *[_type == "informationCard"] | order(order asc) {
    _id, label, buttonLabel, modalTitle, actionType
  }
}`

export type HomeContent = {
  page: {
    tasksHeading?: LocaleString
    informationHeading?: LocaleString
    newsHeading?: LocaleString
    headerImage?: SanityImageSource
    taskCards?: Array<{ label?: LocaleString; subLabel?: LocaleString; href?: string }>
  } | null
  featuredArticle: {
    _id: string
    title?: string
    slug?: { current: string }
    image?: SanityImageSource
  } | null
  articles: Array<{
    _id: string
    title?: string
    slug?: { current: string }
    image?: SanityImageSource
  }>
  infoCards: Array<{
    _id: string
    label?: LocaleString
    buttonLabel?: LocaleString
    modalTitle?: LocaleString
    actionType?: 'reportDamage' | 'lostCard'
  }>
}

export function useHomeContent() {
  const [content, setContent] = useState<HomeContent | null>(null)
  const lang = detectLang()

  useEffect(() => {
    getClient().fetch<HomeContent>(HOME_QUERY, { lang }).then(setContent)
  }, [lang])

  return content
}
